export default "__VITE_ASSET__BRr6YsqN__"